@if (loading.isLoading()) {
  <div class="api-loading-overlay">
    <div class="api-loading-pop-card">
      <div class="pop-dots-container">
        <span class="dot dot-1"></span>
        <span class="dot dot-2"></span>
        <span class="dot dot-3"></span>
      </div>
      <div class="pop-loading-label">Loading...</div>
    </div>
  </div>
}
<router-outlet></router-outlet>


